window.onload = function () {
  var tabs = document.querySelectorAll('.bundle-collection-list-item');
  var sections = document.querySelectorAll('.bundle-collection-product-container');

  function clearActiveClasses() {
    tabs.forEach(tab => tab.classList.remove('active'));
    sections.forEach(section => section.classList.remove('active'));
  }

  tabs.forEach((tab, targetIndex) => {
  tab.onclick = function () {
    const currentTab = document.querySelector('.bundle-collection-list-item.active');
    const currentSection = document.querySelector('.bundle-collection-product-container.active');

    const currentIndex = [...tabs].indexOf(currentTab);
    const collectionIndex = currentIndex.toString();
    const addedCount = (addedProductsPerCollection[collectionIndex] || []).length;
    const maxAllowed = parseInt(currentSection.getAttribute('data-max'), 10);

    if (addedCount !== maxAllowed) {
      showToast(`Please add exactly ${maxAllowed} product(s) before switching collections.`, 'error');
      return;
    }

    // ✅ Allowed to switch tabs now
    tabs.forEach(tab => tab.classList.remove('active'));
    sections.forEach(section => section.classList.remove('active'));

    tabs[targetIndex].classList.add('active');
    sections[targetIndex].classList.add('active');

    const offsetTop = sections[targetIndex].getBoundingClientRect().top + window.scrollY;
    const headerOffset = 300;
    window.scrollTo({
      top: offsetTop - headerOffset,
      behavior: 'smooth'
    });
  };
});


  if (tabs.length > 0) {
    tabs[0].classList.add('active');
    sections[0].classList.add('active');
  }
};
function showToast(message, type = 'info') {
  const toast = document.getElementById('custom-toast');
  toast.textContent = message;
  toast.className = `custom-toast show ${type}`;

  setTimeout(() => {
    toast.classList.remove('show');
  }, 3000);
}

// Track selected products per collection
const addedProductsPerCollection = {};

document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.querySelector('.product-in-box-wrapper-item');
  const bundleSize = parseInt(document.querySelector('.bundle-collection-wrapper').getAttribute('data-bundle-size'), 10);
    const svgMarkup = `
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 0C6.26792 0 0 6.26792 0 14C0 21.7321 6.26792 28 14 28C17.3771 28 20.475 26.8042 22.8933 24.8132L24.8336 22.8681C26.8126 20.4535 28 17.3655 28 14C28 6.26792 21.7321 0 14 0ZM20.5997 14.9115H14.9115V20.5997H13.0885V14.9115H7.40031V13.0885H13.0885V7.40031H14.9115V13.0885H20.5997V14.9115Z" fill="#001777"></path>
    </svg>
  `;
  for (let i = 0; i < bundleSize; i++) {
    const emptyBox = document.createElement('div');
    emptyBox.className = 'product-item-in-box empty tw-flex tw-items-center tw-gap-4 tw-mb-4 tw-p-4 tw-border tw-rounded tw-relative';
    wrapper.appendChild(emptyBox);
      if (i < bundleSize - 1) {
    wrapper.insertAdjacentHTML('beforeend', `<div class="tw-flex tw-justify-center">${svgMarkup}</div>`);
  }
  }
   updateNextButtonState();
  document.querySelectorAll('.add_to_box').forEach(button => {
    button.addEventListener('click', function () {
      
      const variantId = this.getAttribute('data-product-id');
      const image = this.getAttribute('data-product-image');
      const title = this.getAttribute('data-title');
      const price = this.getAttribute('data-price');
      const collectionIndex = this.getAttribute('data-collection-index');
      const maxAllowed = parseInt(this.getAttribute('data-max'), 10);

      if (!addedProductsPerCollection[collectionIndex]) {
        addedProductsPerCollection[collectionIndex] = [];
      }

      if (addedProductsPerCollection[collectionIndex].length >= maxAllowed) {
        showToast(`You can only add up to ${maxAllowed} products from this collection.`, 'error');
         setTimeout(() => {
          goToNextTab();
         }, 1000);
        return;
      }

      const alreadyAdded = addedProductsPerCollection[collectionIndex].find(p => p.id === variantId);
      if (alreadyAdded) return;

      const productObj = {
        id: variantId,
        image: image,
        title: title,
        price: price,
        collectionIndex: collectionIndex
      };

      addedProductsPerCollection[collectionIndex].push(productObj);
      renderProduct(productObj);
      updateNextButtonState();

      this.textContent = 'Added';
      this.setAttribute('disabled', true);
      this.classList.add('tw-opacity-50', 'tw-cursor-not-allowed');
    });
  });
});

function renderProduct(product) {
  const boxes = document.querySelectorAll('.product-item-in-box.empty');

  if (boxes.length === 0) return; // All boxes filled

  const targetBox = boxes[0];
  targetBox.classList.remove('empty');

  targetBox.innerHTML = `
    <img class="box-image tw-w-16 tw-h-16 tw-object-cover tw-rounded" src="${product.image}" alt="${product.title}">
    <button class="remove-product tw-absolute tw-top-2 tw-right-2 tw-text-gray-500 hover:tw-text-red-600" data-id="${product.id}" aria-label="Remove product">
      <svg width="10" height="10" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.61601 5.6791L1.7975 1.20478C1.47816 0.908244 0.960472 0.908182 0.641212 1.20464C0.321952 1.50109 0.322019 1.9818 0.641361 2.27834L5.45987 6.75266C5.67276 6.95035 5.6728 7.27083 5.45996 7.46846L0.6427 11.9416C0.323441 12.2381 0.323506 12.7188 0.642849 13.0153C0.962191 13.3119 1.47988 13.3119 1.79914 13.0155L6.6164 8.5423C6.82924 8.34466 7.17437 8.3447 7.38727 8.54239L12.2058 13.0167C12.5251 13.3132 13.0428 13.3133 13.3621 13.0169C13.6813 12.7204 13.6813 12.2397 13.3619 11.9432L8.54341 7.46883C8.33051 7.27114 8.33047 6.95067 8.54331 6.75303L13.3606 2.27986C13.6798 1.9834 13.6798 1.50269 13.3604 1.20616C13.0411 0.909626 12.5234 0.909564 12.2041 1.20602L7.38687 5.67919C7.17403 5.87683 6.8289 5.87679 6.61601 5.6791Z" fill="#FFFFFF"></path>
              </svg>
    </button>
  `;

  targetBox.setAttribute('data-product-id', product.id);
  targetBox.setAttribute('data-collection-index', product.collectionIndex);

  targetBox.querySelector('.remove-product').addEventListener('click', function () {
    const idToRemove = this.getAttribute('data-id');
    const collectionIndex = product.collectionIndex;

    // Clear box
    targetBox.classList.add('empty');
    targetBox.innerHTML = ''; // Remove product content

    // Remove from state
    const index = addedProductsPerCollection[collectionIndex].findIndex(p => p.id === idToRemove);
    if (index > -1) addedProductsPerCollection[collectionIndex].splice(index, 1);

    // Enable button again
    const addButton = document.querySelector(`.add_to_box[data-product-id="${idToRemove}"]`);
    if (addButton) {
      addButton.textContent = 'Add to box';
      addButton.removeAttribute('disabled');
      addButton.classList.remove('tw-opacity-50', 'tw-cursor-not-allowed');
    }

    updateNextButtonState();
  });
}

function updateNextButtonState() {
  const bundleSize = parseInt(document.querySelector('.bundle-collection-wrapper').getAttribute('data-bundle-size'), 10);
  const nextButton = document.querySelector('.product-in-box-wrapper-bottom .button--primary:last-of-type');
  const productInBoxWrapper = document.querySelector('.product-in-box-wrapper');
  const leftToAddSpan = document.querySelector('.products-left-to-add');
  const productsToAddText = document.querySelector('.product-in-box-wrapper-heading');
  const noproductsToAddText = document.querySelector('.no-product-in-box-wrapper-heading');

  const allAdded = Object.values(addedProductsPerCollection).flat();
  const remaining = bundleSize - allAdded.length;
if(remaining ==0  ){
productsToAddText.classList.add("visually-hidden")
noproductsToAddText.classList.remove("visually-hidden")
}else{
  productsToAddText.classList.remove("visually-hidden")
noproductsToAddText.classList.add("visually-hidden")
}
  // ✅ Update the count in the heading
  
  if (productsToAddText && productsToAddText.dataset.message) {
    const template = productsToAddText.dataset.message;
    productsToAddText.textContent = template.replace(/\$value/g, remaining);
  }

  // ✅ Toggle wrapper visibility
  if (allAdded.length === 0) {
    productInBoxWrapper.classList.add('visually-hidden');
  } else {
    productInBoxWrapper.classList.remove('visually-hidden');
  }

  // ✅ Button state
  if (allAdded.length === bundleSize) {
    nextButton.textContent = 'Add to cart';
    nextButton.classList.add('ready-to-checkout');
    nextButton.onclick = () => {
      addBundleToCart(allAdded);
    };
  } else {
    nextButton.textContent = 'Next';
    nextButton.classList.remove('ready-to-checkout');
    nextButton.onclick = () => {
      goToNextTab();
    };
  }
}



// Scroll the page to the new section
function goToNextTab() {
  const tabs = document.querySelectorAll('.bundle-collection-list-item');
  const sections = document.querySelectorAll('.bundle-collection-product-container');

  let currentIndex = -1;
  tabs.forEach((tab, index) => {
    if (tab.classList.contains('active')) {
      currentIndex = index;
    }
  });

  if (currentIndex === -1) return;

  const currentCollectionIndex = currentIndex.toString(); // Ensure it's a string for object key
  const addedProducts = addedProductsPerCollection[currentCollectionIndex] || [];
  const maxAllowed = parseInt(tabs[currentIndex].getAttribute('data-max'), 10);

  if (addedProducts.length !== maxAllowed) {
    showToast(`Please add exactly ${maxAllowed} product(s) to continue.`, 'error');
    return;
  }

  const nextIndex = currentIndex + 1;
  if (nextIndex < tabs.length) {
    tabs[currentIndex].classList.remove('active');
    sections[currentIndex].classList.remove('active');

    tabs[nextIndex].classList.add('active');
    sections[nextIndex].classList.add('active');

    const offsetTop = sections[nextIndex].getBoundingClientRect().top + window.scrollY;
    const headerOffset = 300;
    window.scrollTo({
      top: offsetTop - headerOffset,
      behavior: 'smooth'
    });
  }
}




function addBundleToCart(products) {
  const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  const items = products.map(product => ({
    id: parseInt(product.id, 10),
    quantity: 1
  }));

  const bundleData = {
    items: items,
    sections: cartDrawer ? cartDrawer.getSectionsToRender().map(section => section.id) : [],
    sections_url: window.location.pathname
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(bundleData)
  })
    .then(response => {
      if (!response.ok) throw new Error('Failed to add bundle to cart');
      return response.json();
    })
    .then(cartResponse => {
      if (!cartDrawer) {
        window.location.href = '/cart';
        return;
      }

      cartDrawer.setActiveElement(document.activeElement);
      cartDrawer.renderContents(cartResponse);

      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
      // 🔄 Reset all selections and UI
      resetBundleState();
    })
    .catch(error => {
      console.error('Cart error:', error);
      showToast('Something went wrong while adding your bundle. Please try again.', 'error');

    });
}
function resetBundleState() {
  // Clear added product tracking
  for (let key in addedProductsPerCollection) {
    addedProductsPerCollection[key] = [];
  }

  // Reset product boxes
  const boxes = document.querySelectorAll('.product-item-in-box');
  boxes.forEach(box => {
    box.classList.add('empty');
    box.innerHTML = '';
  });

  // Enable all "Add to box" buttons again
  document.querySelectorAll('.add_to_box').forEach(button => {
    button.textContent = 'Add to box';
    button.removeAttribute('disabled');
    button.classList.remove('tw-opacity-50', 'tw-cursor-not-allowed');
  });

  // Reset to first tab and section
  const tabs = document.querySelectorAll('.bundle-collection-list-item');
  const sections = document.querySelectorAll('.bundle-collection-product-container');

  tabs.forEach(tab => tab.classList.remove('active'));
  sections.forEach(section => section.classList.remove('active'));

  if (tabs[0]) tabs[0].classList.add('active');
  if (sections[0]) sections[0].classList.add('active');

  // Scroll to the first section
  const offsetTop = sections[0].getBoundingClientRect().top + window.scrollY;
  const headerOffset = 300;
  window.scrollTo({
    top: offsetTop - headerOffset,
    behavior: 'smooth'
  });

  // Reset UI states and button
  updateNextButtonState();
}
